const SOIL_SURVEY_URL = "https://SDMDataAccess.sc.egov.usda.gov/Spatial/SDM.wms";
const SOIL_SURVEY_TIMEOUT_MS = 15000;

function getGeometry(feature) {
	const parsedFeature = typeof feature === "string" ? JSON.parse(feature) : feature;
	return JSON.parse(parsedFeature.featureGeoJSON).geometry;
}

function getCentroid(geometry) {
	const ring = geometry.coordinates[0];
	const count = ring.length;
	let doubleArea = 0;
	let cx = 0;
	let cy = 0;

	for (let i = 0; i < count; i++) {
		const [x0, y0] = ring[i];
		const [x1, y1] = ring[(i + 1) % count];
		const cross = x0 * y1 - x1 * y0;
		doubleArea += cross;
		cx += (x0 + x1) * cross;
		cy += (y0 + y1) * cross;
	}

	if (doubleArea === 0) {
		return [
			ring.reduce((sum, p) => sum + p[0], 0) / count,
			ring.reduce((sum, p) => sum + p[1], 0) / count,
		];
	}

	return [cx / (3 * doubleArea), cy / (3 * doubleArea)];
}

export async function fetchSoilSurveyText(feature) {
	const [x, y] = getCentroid(getGeometry(feature));
	const url =
		`${SOIL_SURVEY_URL}?SERVICE=WMS&VERSION=1.1.1&REQUEST=GetFeatureInfo&QUERY_LAYERS=mapunitpolyextended` +
		`&LAYERS=MapunitPoly&WIDTH=10&HEIGHT=10&X=0&Y=0&SRS=EPSG:3857&BBOX=${x},${y},${x + 0.001},${y + 0.001}`;

	const controller = new AbortController();
	const timer = setTimeout(() => controller.abort(), SOIL_SURVEY_TIMEOUT_MS);
	try {
		const response = await fetch(url, { signal: controller.signal });
		if (!response.ok) {
			throw new Error(`Soil survey request failed with status ${response.status}`);
		}
		const text = await response.text();
		if (!/muname\s*=/i.test(text)) {
			throw new Error("Soil survey response did not include a soil map unit");
		}
		return text;
	} finally {
		clearTimeout(timer);
	}
}
